import * as React from "react";
import { Route } from "react-router-dom";
import { ErrorBoundary } from "./";

type AppRouteProps = Omit<
  React.ComponentPropsWithoutRef<typeof Route>,
  "component"
>;

export const AppRoute = ({ render, ...routeProps }: AppRouteProps) => (
  <Route
    {...routeProps}
    render={(props) => (
      <ErrorBoundary
        label={(routeProps.path || "Empty path-string").toString()}
      >
        {render?.(props)}
      </ErrorBoundary>
    )}
  />
);
